import { SelectedSystemType } from 'data/types';
import { isDuctedCompatibilitySystem } from 'utils/ducted-quote-layout';

export function showsAccessoryChipConfigurationName(
  system: Pick<SelectedSystemType, 'tags' | 'configuration'>
): boolean {
  if (isDuctedCompatibilitySystem(system)) {
    return false;
  }

  const { condensers } = system.configuration;
  const isDuctedSystem =
    condensers.length > 0 &&
    condensers.every((condenser) => condenser.type === 'ducted');

  return !isDuctedSystem;
}
